<template>
	<div>
		<a-page-header style="background: #fff;" title="特价商品详情" />
		<a-row>
			<a-col :span="8">
				<div class="mainBox">
					<div class="contentBox" v-if="goodsDetail">
						<a-page-header :ghost="false" :title="goodsDetail.goodsName" :subTitle="'ID ' + addSaleGoodsForm.saleGoodsId">
							<a-descriptions size="small" :column="1">
								<a-descriptions-item label="缩略图">
									<a-avatar shape="square" :src="goodsDetail.goodsThumb" :size="70" />
								</a-descriptions-item>
								<a-descriptions-item label="类型">
									<a-tag color="blue">{{goodsDetail.className}}</a-tag>
								</a-descriptions-item>
								<a-descriptions-item label="原始库存"><strong>{{goodsDetail.goodsInventory}} {{goodsDetail.goodsUnit}}</strong></a-descriptions-item>
								<a-descriptions-item label="特价库存"><strong>{{addSaleGoodsForm.saleGoodsInventory}} {{goodsDetail.goodsUnit}}</strong></a-descriptions-item>
								<a-descriptions-item label="售价"><strong>{{goodsDetail.goodsPrice}} 元</strong></a-descriptions-item>
								<a-descriptions-item label="特价"><strong>{{addSaleGoodsForm.saleGoodsPrice}} 元</strong></a-descriptions-item>
								<a-descriptions-item label="每人限购"><strong>{{addSaleGoodsForm.saleGoodsEvery}} {{goodsDetail.goodsUnit}}</strong></a-descriptions-item>
								<a-descriptions-item label="送积分"><strong>{{addSaleGoodsForm.saleGoodsIntegral}} 积分</strong></a-descriptions-item>
								<a-descriptions-item label="上架日期"><a-tag color="green" v-for="item in addSaleGoodsForm.dataArr" :key="item">{{item}}</a-tag></a-descriptions-item>
								<a-descriptions-item label="添加特价时间">{{addSaleGoodsForm.addTime}}</a-descriptions-item>
							</a-descriptions>
						</a-page-header>
					</div>
				</div>
			</a-col>

			<a-col :span="16" style="padding: 20px 20px 20px 0;">
				<div style="background: #fff;padding:50px 20px">
					<a-form-model ref="addSaleGoodsForm" :model="addSaleGoodsForm" :rules="addSaleGoodsFormRules" :label-col="{ span: 8 }"
					 :wrapper-col="{ span: 10 }">
						<a-form-model-item label="特价价格" prop="saleGoodsPrice">
							<a-input-number :min="0" v-model="addSaleGoodsForm.saleGoodsPrice" style="width: 150px;" /> 元
						</a-form-model-item>
						<a-form-model-item label="特价总限购" prop="saleGoodsInventory">
							<a-input-number :min="0" style="width: 150px;" :max="goodsDetail.goodsInventory" v-model="addSaleGoodsForm.saleGoodsInventory" />
							{{goodsDetail.goodsUnit}}
						</a-form-model-item>
						<a-form-model-item label="每人限购" prop="saleGoodsEvery">
							<a-input-number :min="0" style="width: 150px;" :max="goodsDetail.goodsInventory" v-model="addSaleGoodsForm.saleGoodsEvery" />
							{{goodsDetail.goodsUnit}}
						</a-form-model-item>
						<a-form-model-item label="送积分" prop="saleGoodsIntegral">
							<a-input-number :min="0" style="width: 150px;" v-model="addSaleGoodsForm.saleGoodsIntegral" /> 积分
						</a-form-model-item>
						<a-form-model-item label="上架日期" prop="saleGoodsDate">
							<a-range-picker :locale="locale" :value="[moment(addSaleGoodsForm.saleGoodsBegin,'YYYY-MM-DD'),moment(addSaleGoodsForm.saleGoodsEnd,'YYYY-MM-DD')]" format="YYYY-MM-DD" @change="editDateChange" />
						</a-form-model-item>
						<a-form-model-item :wrapper-col="{ span: 10, offset: 8 }">
							<a-button type="primary" @click="addSubmit">
								保存
							</a-button>
						</a-form-model-item>
					</a-form-model>
					</a-modal>
				</div>
			</a-col>
		</a-row>
	</div>
</template>

<script>
	import moment from "moment"
	import 'moment/locale/zh-cn'
	import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
	
	export default {
		data() {
			return {
				moment,
				locale,
				loading: false,
				goodsDetail: '',
				addSaleGoodsForm: {},
				addSaleGoodsFormRules: {
					saleGoodsPrice: [{
						required: true,
						message: '请填写特价价格',
						trigger: 'blur'
					}],
					saleGoodsInventory: [{
						required: true,
						message: '请填写特价总限购',
						trigger: 'blur'
					}],
					saleGoodsEvery: [{
						required: true,
						message: '请填写每人限购',
						trigger: 'blur'
					}],
					saleGoodsDate: [{
						required: true,
						message: '请选择上架日期',
						trigger: 'change'
					}],
				},
			}
		},
		mounted() {
			this.id = this.$route.query.id
			this.getDetail()
		},
		methods: {
			editDateChange(value){
				// console.log(value)
				this.addSaleGoodsForm.saleGoodsBegin = moment(value[0]).format('YYYY-MM-DD')
				this.addSaleGoodsForm.saleGoodsEnd = moment(value[1]).format('YYYY-MM-DD')
			},
			
			addSubmit() {
				this.$refs.addSaleGoodsForm.validate(valid => {
					if (valid) {
						this.$http.post('/admin/index.php/admin/Shop/specialSave', {
							id: this.id,
							saleGoodsId:this.addSaleGoodsForm.saleGoodsId,
							saleGoodsPrice: this.addSaleGoodsForm.saleGoodsPrice,
							saleGoodsInventory: this.addSaleGoodsForm.saleGoodsInventory,
							saleGoodsEvery: this.addSaleGoodsForm.saleGoodsEvery,
							saleGoodsIntegral: this.addSaleGoodsForm.saleGoodsIntegral,
							saleGoodsBegin: this.addSaleGoodsForm.saleGoodsBegin,
							saleGoodsEnd: this.addSaleGoodsForm.saleGoodsEnd
						}).then(res => {
							if (res.data.code == 1) {
								this.$message.success(res.data.msg)
								this.getDetail()
							} else {
								this.$message.error(res.data.msg)
							}
						})
					}
				});
			},

			getDetail() {
				this.loading = true
				this.$http.post('/admin/index.php/admin/Shop/specialInfo', {
					id: this.id,
				}).then(res => {
					this.loading = false
					if (res.data.code == 1) {
						this.addSaleGoodsForm = res.data.data
						var date = []
						date.push(res.data.data.saleGoodsBegin)
						date.push(res.data.data.saleGoodsEnd)
						this.addSaleGoodsForm.saleGoodsDate = date
						// console.log(this.addSaleGoodsForm.saleGoodsDate)
						this.getGoodsDetail(res.data.data.saleGoodsId)
					}
				})
			},

			getGoodsDetail(id) {
				this.$http.post('/admin/index.php/admin/Shop/goodsInfo', {
					id: id
				}).then((res) => {
					if (res.data.code == 1) {
						this.goodsDetail = res.data.data
					}
				})
			},
		},
	}
</script>

<style scoped="">
</style>
